<div class="body" [formGroup]="formGroup">

    <div class="sidenav-wrapper">

        <app-sidenav></app-sidenav>

    </div>

    <div @show class="content">

        <div class="inactive-customer" *ngIf="(customerDetailViewComponentService.customer$|async) && !(customerDetailViewComponentService.customer$|async)?.customeractive">

            Dieser Kunde ist nicht aktiv.

        </div>

        <div class="content-row-2">

            <div class="section-wrapper customer-data-wrapper" formGroupName="customer">

                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">domain</mat-icon>
        
                    <span class="text">
                        Kopfdaten
                    </span>
        
                    <span class="spacer"></span>
        
                </div>
    
                <div class="section-content">
    
                    <app-customer-form  style="flex: 1;" [editMode]="!disabled" [showIdGenerator]="false"></app-customer-form>

                    <app-concurrency-label [entityIsSupported]="false"></app-concurrency-label>
        
                </div>
            </div>
    
            <div class="section-wrapper address-data-wrapper">
    
                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">location_on</mat-icon>
        
                    <span class="text">
                        Adresse
                    </span>
        
                    <span class="spacer"></span>

                    <button *ngIf="addressControl.valid" mat-icon-button matTooltip="Adresse auf Karte anzeigen" (click)="showAddress()">
                        <mat-icon>map</mat-icon>
                    </button>
        
                </div>

                <div class="section-content">

                    <app-address-form formGroupName="address" [appearance]="appearance" style="flex: 1; width: 100%;" [editMode]="!disabled"></app-address-form>

                </div>
    
            </div>

        </div>

        <div>

            <div class="section-wrapper issue-data-wrapper">
    
                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">router</mat-icon>
        
                    <span class="text">
                        Alle Vertragsartikel
                    </span>
        
                    <span class="spacer"></span>
        
                </div>

                <div class="limited-height">
                    <app-customer-contract-items></app-customer-contract-items>
                </div>

            </div>

        </div>

        <div class="content-row-2">

            <div class="section-wrapper issue-data-wrapper">
    
                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">assessment</mat-icon>
        
                    <span class="text">
                        Vorgänge
                    </span>
        
                    <span class="spacer"></span>

                    <button mat-icon-button [matMenuTriggerFor]="customerIssueMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
        
                </div>

                <div class="limited-height">
                    <app-issue-table></app-issue-table>
                </div>
                
            </div>

            <div class="section-wrapper offer-data-wrapper" formGroupName="customer">
    
                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">euro_symbol</mat-icon>
        
                    <span class="text">
                        Angebote
                    </span>
        
                    <span class="spacer"></span>

                    <button mat-icon-button (click)="addOffer()" matTooltip="Neues Angebot anlegen">
                        <mat-icon>add</mat-icon>
                    </button>
        
                </div>

                <div class="limited-height">
                    <app-offer-table></app-offer-table>
                </div>

            </div>

        </div>

        <div class="content-row-2">

            <div class="section-wrapper contract-data-wrapper">
    
                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">assignment</mat-icon>
        
                    <span class="text">
                        Verträge
                    </span>
        
                    <span class="spacer"></span>

                    <button mat-icon-button (click)="addContract()"  matTooltip="Neuen Vertrag anlegen">
                        <mat-icon>add</mat-icon>
                    </button>
        
                </div>

                <div class="limited-height">
    
                    <app-contract-table></app-contract-table>
        
                </div>
            </div>

            <div class="section-wrapper contact-data-wrapper">
    
                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">person</mat-icon>
        
                    <span class="text">
                        Ansprechpartner
                    </span>
        
                    <span class="spacer"></span>

                    <button mat-icon-button (click)="addContact()" matTooltip="Neuen Ansprechpartner anlegen">
                        <mat-icon>add</mat-icon>
                    </button>

                    <button mat-icon-button matTooltip="Bestehenden Ansprechpartner hinzufügen">
                        <mat-icon>person_add</mat-icon>
                    </button>
        
                </div>

                <div class="limited-height">
    
                    <app-contact-table></app-contact-table>
        
                </div>
            </div>

        </div>

    </div>

</div>

<mat-menu #customerIssueMenu="matMenu">

    <button mat-menu-item class="dropdown-item" (click)="toggleIssueTypeVisibility($event, 'changes')">
        <mat-icon class="dropdown-icon">{{(customerDetailViewComponentService.visibleIssueTypes$|async)?.changes? 'done': 'clear'}}</mat-icon>
        <span>Changes/RFCs anzeigen</span>
    </button>

    <button mat-menu-item class="dropdown-item" (click)="toggleIssueTypeVisibility($event, 'projects')">
        <mat-icon class="dropdown-icon">{{(customerDetailViewComponentService.visibleIssueTypes$|async)?.projects? 'done': 'clear'}}</mat-icon>
        <span>Projekte anzeigen</span>
    </button>

    <button mat-menu-item class="dropdown-item" (click)="toggleIssueTypeVisibility($event, 'incidents')">
        <mat-icon class="dropdown-icon">{{(customerDetailViewComponentService.visibleIssueTypes$|async)?.incidents? 'done': 'clear'}}</mat-icon>
        <span>Tickets anzeigen</span>
    </button>

    <button mat-menu-item class="dropdown-item" (click)="toggleIssueTypeVisibility($event, 'issues')">
        <mat-icon class="dropdown-icon">{{(customerDetailViewComponentService.visibleIssueTypes$|async)?.issues? 'done': 'clear'}}</mat-icon>
        <span>Vorgänge anzeigen</span>
    </button>

</mat-menu>
